module.exports = __webpack_public_path__ + "img/backDark.7c34eced.png";